"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_1 = require("react");
const react_mdc_web_1 = require("react-mdc-web");
const APP_MESSAGE = 'APP_MESSAGE';
const style = {
    hidden: {
        visibility: 'hidden',
    },
};
class Snackbar extends react_1.PureComponent {
    constructor() {
        super();
        this.initialRender = true;
        this.show = (event) => {
            this.setState({
                message: event.detail.message,
                open: true,
            });
        };
        this.hide = () => {
            const snackbarStillMounted = this.snackbarElement;
            if (snackbarStillMounted) {
                this.setState({ open: false });
            }
        };
        this.state = {
            message: '',
            open: false,
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.state.open !== nextState.open;
    }
    componentWillUpdate() {
        this.initialRender = false;
    }
    componentDidMount() {
        const useCapture = false;
        document.body.addEventListener(APP_MESSAGE, this.show, useCapture);
    }
    componentWillUnmount() {
        document.body.removeEventListener(APP_MESSAGE, this.show);
    }
    render() {
        const { open, message } = this.state;
        return (React.createElement(react_mdc_web_1.Snackbar, { open: open, onTimeout: this.hide, ref: instance => this.snackbarElement = instance, style: Object.assign({}, this.initialRender && style.hidden) }, message));
    }
}
Snackbar.emitMessage = (message) => {
    const messageEvent = new CustomEvent(APP_MESSAGE, {
        detail: { message },
    });
    document.body.dispatchEvent(messageEvent);
};
exports.Snackbar = Snackbar;



//////////////////
// WEBPACK FOOTER
// ./src/components/Snackbar.tsx
// module id = 384
// module chunks = 0